var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideosection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "40px",
    viewBox: "0 0 59 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13E7692A-23A1-4E14-A18B-AC3125A9AE18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products---detail--add-section",
    transform: "translate(-924.000000, -327.000000)",
    stroke: "#E10210",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(868.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(57.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666643,0 L28.5,0 C35.4955986,0 41.1666597,5.67105996 41.1666597,12.6666669 L41.1666597,13.0625 L47.3099886,9.22133308 C49.2623583,8.00109798 51.7231429,7.9364862 53.7368583,9.0525842 C55.7505714,10.1686833 57,12.2896697 57,14.592 L57,23.408 C57.0046056,25.7125974 55.7569896,27.8378044 53.7424044,28.9570184 C51.7278209,30.0762324 49.2642849,30.0127777 47.3099886,28.7913327 L41.1666597,24.9375 L41.1666597,25.3333346 C41.1666597,32.3289408 35.4955986,38 28.5,38 L12.6666643,38 C5.67105825,38 0,32.3289408 0,25.3333346 L0,12.6666669 C0,5.67105996 5.67105825,0 12.6666643,0 Z",
    id: "Vector-16",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5833288,25.3333333 C17.0855262,25.3333333 14.2499968,22.4978032 14.2499968,19 C14.2499968,15.5021966 17.0855262,12.6666667 20.5833288,12.6666667 C24.0811312,12.6666667 26.9166607,15.5021966 26.9166607,19 C26.9166607,20.6797042 26.2494011,22.2906125 25.0616708,23.4783431 C23.8739406,24.6660736 22.2630326,25.3333333 20.5833288,25.3333333 Z",
    id: "Vector-17",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1666575,
    y1: 13.0625,
    x2: 41.1666575,
    y2: 24.9375,
    id: "Vector-18"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosection);
export default __webpack_public_path__ + "static/media/Video section.d154857824f019dcb92aa7d97205f61f.svg";
export { ForwardRef as ReactComponent };